
















































import { Component, Vue } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import Popup from '@/components/default/Popup.vue';
import DataGrid from '@/components/default/Datagrid.vue';
import { DxForm  } from 'devextreme-vue';
import { DxRequiredRule, DxItem, DxLabel } from 'devextreme-vue/form';
import { InvoicingClosedLogsClient, CreateInvoicingClosedLogCommand } from '@/data/web-api-client';
import moment from 'moment';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';

@Component({
  components: {
    DataGrid,
    Popup,
    DxForm,
    DxLabel,
    DxItem,
    DxRequiredRule
  },
})
export default class InvoicingClosedLogsOverviewDialog extends Vue {
  public showPopup = false;
  public saving = false;
  public showNewCloseInvoicingLogForm = false;
  public disableCloseInvoicingButton = false;
  public datasource = new DataSource({
    key: 'id',
    store: new dxCustomStore({
      load: async () => {
        const result = await this.client.get();
        const temp = [...result];
        const lastLog = temp?.sort((a, b) => a.closedDate!.valueOf() - b.closedDate!.valueOf())?.pop();

        if (!lastLog) {
          this.setBtnDisabled(false);
        } else {
          const lastLogDate = moment(lastLog.closedDate!);
          const today = moment();

          this.setBtnDisabled(lastLogDate.isSame(today, 'month'));
        }

        return result;
      }
    })
  });

  public newLogModel: {
    description: string
  } = {
    description: ''
  };

  private client = new InvoicingClosedLogsClient(undefined, this.$axios);

  public async show() {
    this.showPopup = true;
  }

  public hide() {
    this.showPopup = false;
  }

  public showForm() {
    this.showNewCloseInvoicingLogForm = true;

    setTimeout(() => {
      (this.$refs.newInvoiceClosingLogForm as DxForm).instance?.getEditor('description')?.focus();
    }, 500);
  }

  public hideForm() {
    this.newLogModel.description = '';
    this.showNewCloseInvoicingLogForm = false;
  }

  public async saveNewLog() {
    try {
      this.saving = true;

      const validationResult = (this.$refs.newInvoiceClosingLogForm as DxForm).instance?.validate();

      if (!validationResult?.isValid && validationResult?.brokenRules && validationResult.brokenRules[0] && validationResult.brokenRules[0].message) {
        notificationService.showErrorMessage(validationResult!.brokenRules![0].message!);

        return;
      }

      await this.client.create(CreateInvoicingClosedLogCommand.fromJS({
        description: this.newLogModel.description
      }));

      this.hideForm();
      this.datasource.reload();

      this.$emit('invoiceClosingLogCreated');
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  private setBtnDisabled(val: boolean) {
    this.disableCloseInvoicingButton = val;
  }

  get columns() {
    const self = this;

    return [
      {
        dataField: 'closedDate',
        caption: this.$t('objects.invoicingClosedLogs.tableHeaders.date')
      },
      {
        dataField: 'closedByName',
        caption: this.$t('objects.invoicingClosedLogs.tableHeaders.user')
      },
      {
        caption: this.$t('objects.invoicingClosedLogs.tableHeaders.action'),
        calculateCellValue(value: any) {
          return self.$t('objects.invoicingClosedLogs.closedInvoicing');
        }
      },
      {
        dataField: 'description',
        caption: this.$t('objects.invoicingClosedLogs.tableHeaders.description')
      }
    ];
  }

  get validationRules() {
    return [
      {
        type: 'required',
        message: this.$t('objects.invoicingClosedLogs.descriptionRequired'),
      }
    ]
  }
}
